/**
 * The PasswordValidador class provides methods for validating passwords.
 *
 * @author Maria Eduarda Franke
 * @class
 * @name PasswordValidador
 */
export default class PasswordValidador {

    static validate(password) {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
        return passwordRegex.test(password)
    }

    static hasMinLength(password) {
        return password.length >= 8
    }

    static hasUpperCase(password) {
        const upperCaseRegex = /[A-Z]/
        return upperCaseRegex.test(password)
    }

    static hasLowerCase(password) {
        const lowerCaseRegex = /[a-z]/
        return lowerCaseRegex.test(password)
    }

    static hasNumber(password) {
        const numberRegex = /\d/
        return numberRegex.test(password)
    }

    static hasSpecialChar(password) {
        const specialCharRegex = /[@$!%*?&¨()_\-+=.]/
        return specialCharRegex.test(password)
    }

    /**
    * Validates a password dynamically.
    *
    * @author Maria Eduarda Franke
    * @param {string} password - The password to be validated.
    * @returns {Array} - An array of error messages indicating the validation errors.
    *
    */
    static validateDynamic(password) {
        const errorMessages = []

        if (!PasswordValidador.hasMinLength(password))
            errorMessages.push('A senha deve ter mais de 8 caracteres!')

        if (!PasswordValidador.hasUpperCase(password))
            errorMessages.push('A senha deve ter letras maiúsculas!')

        if (!PasswordValidador.hasNumber(password))
            errorMessages.push('A senha deve ter um número!')

        if (!PasswordValidador.hasLowerCase(password))
            errorMessages.push('A senha deve ter letras minúsculas!')

        if (!PasswordValidador.hasSpecialChar(password))
            errorMessages.push('A senha deve ter caracteres especiais!')

        return errorMessages
    }

}